export default function AdminStatusMark({ kind, label, title }) {
  return (
    <span className={`admin-mark admin-mark--${kind}`} title={title || label}>
      <i aria-hidden="true" />
      <span>{label}</span>
    </span>
  )
}
